import React, { ComponentType } from 'react';
import { components, GroupProps } from 'react-select';
import styled from 'styled-components';

import Button from '@lt/components/components/ButtonTs';
import { DestinationOption, GroupedOption, GroupName } from '@lt/api/dist/methods/references/types';

import {
  destinationPickerName,
  defaultExtendedGroupIds,
  groupParams,
  START_OPTIONS_COUNT,
} from '../../constants';

export const Group: ComponentType<GroupProps<DestinationOption, false>> = ({
  children,
  ...props
}) => {
  const {
    data,
    selectProps: { changeOptions, isMobile },
  } = props;
  const customData = data as GroupedOption;
  const { groupName, fullOptionsCount } = customData;
  if (!groupParams[groupName]) return null;
  const { label, showMoreTitle } = groupParams[groupName];
  const groupIds: GroupName[] = isMobile ? [groupName] : defaultExtendedGroupIds;
  const shownOptionsCount = fullOptionsCount ? fullOptionsCount - START_OPTIONS_COUNT : 0;
  return (
    <>
      <components.Group
        className={`${destinationPickerName}__${groupName}`}
        {...props}
        label={label}
      >
        {children}
      </components.Group>
      {showMoreTitle && changeOptions && shownOptionsCount > 0 ? (
        <StyledButton onClick={() => changeOptions(groupIds)}>
          {showMoreTitle(shownOptionsCount)}
        </StyledButton>
      ) : null}
    </>
  );
};

const StyledButton = styled(Button)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    border: none;
    background: none;
    width: auto;
    padding: 0 0 8px 8px;
    height: auto;
    font-size: 12px;
  }
`;
